export type StatusColor = 'neutral' | 'info' | 'positive' | 'warning' | 'critical'

export function getStatusColor(status: string): StatusColor {
  const statusColorMap: Record<string, StatusColor> = {
    paid: 'positive',
    approved: 'info',
    in_payroll: 'info',
    sent_to_pay: 'info',
    pending: 'warning',
    changes_requested: 'warning',
    rejected: 'critical',
    draft: 'neutral',
    reversed: 'neutral',
  }

  return statusColorMap[status] || 'neutral'
}
